import React from 'react';
import { observer } from 'src/utils/mobx-react';
import { UniverseComponent } from 'src/domains/common/universes';

export const BrandIcon = observer('BrandIcon', (): JSX.Element => {
    return <UniverseComponent>{(UniverseModule) => <UniverseModule.BrandIcon />}</UniverseComponent>;
});
